import { useModal } from "@/features/modal/ModalStackManager";
import { FormButtonBox } from "@/features/standard/form/FormButtonBox";
import { FormMain } from "@/features/standard/form/FormMain";
import { FormWrapper } from "@/features/standard/form/FormWrapper";
import customAlert from "@/features/ui/alert/Alert";
import { Button, Flex, Text, TextInput, Title } from "@mantine/core";
import { IconTrash } from "@tabler/icons-react";
import { useEffect, useRef, useState } from "react";

const BarcodeInput = Object.assign(FormMain, {
  Wrapper: FormWrapper,
  ButtonBox: FormButtonBox,
  Subtitle: Title,
  Input: TextInput,
  Text: Text,
  Button: Button,
});

export const BarcodeInputForm = () => {
  const { closeModal } = useModal();
  const [inputs, setInputs] = useState<string[]>([""]);
  const inputRefs = useRef<(HTMLInputElement | null)[]>([]);

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>, index: number) => {
    if (event.key === "Enter") {
      event.preventDefault();
      const newValue = inputs[index].trim(); // 현재 입력값 가져오기
      if (newValue === "") {
        return; // 빈 값은 추가하지 않음
      }

      // 중복 검사
      if (inputs.some((input, i) => input.trim() === newValue && i !== index)) {
        customAlert("중복된 바코드입니다.", "중복된 바코드는 입력할 수 없습니다.", "red");
        setInputs((prevInputs) => {
          const updatedInputs = [...prevInputs];
          updatedInputs[index] = ""; // 중복된 값 비우기
          return updatedInputs;
        });
        return;
      }
      setInputs((prevInputs) => [...prevInputs, ""]); // 새로운 입력 필드 추가
    }
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>, index: number) => {
    const newInputs = [...inputs];
    newInputs[index] = event.target.value;
    setInputs(newInputs);
  };

  const handleRemoveInput = (index: number) => {
    setInputs((prevInputs) => prevInputs.filter((_, i) => i !== index));
    inputRefs.current = inputRefs.current.filter((_, i) => i !== index);
  };

  useEffect(() => {
    setInputs([""]);
    inputRefs.current = [];
  }, []);

  useEffect(() => {
    if (inputRefs.current.length > 0) {
      inputRefs.current[inputRefs.current.length - 1]?.focus();
    }
  }, [inputs]);

  const handleReturnBarcodeInputs = () => {
    const values = inputs.filter((input) => input !== "");
    closeModal(values);
  };

  return (
    <BarcodeInput.Wrapper>
      <Flex direction="column" gap="md" w="100%">
        {inputs.map((input, index) => (
          <Flex w="100%" justify={"flex-end"} gap={"xl"} align={"center"}>
            <BarcodeInput.Text>{index + 1}.</BarcodeInput.Text>
            <TextInput
              w={"100%"}
              size="sm"
              ref={(el) => (inputRefs.current[index] = el)}
              value={input}
              aria-label="Enter Input And Take a Barcode"
              data-autofocus
              onKeyDown={(event) => handleKeyDown(event, index)}
              onChange={(event) => handleChange(event, index)}
              disabled={index !== inputs.length - 1}
            />
            <BarcodeInput.Button
              disabled={!index}
              onClick={() => handleRemoveInput(index)}
              leftIcon={<IconTrash />}
              color="red"
              variant="white"
            >
              {"삭제"}
            </BarcodeInput.Button>
          </Flex>
        ))}
      </Flex>
      <BarcodeInput.ButtonBox>
        <BarcodeInput.Button color="gray" onClick={closeModal}>
          취소
        </BarcodeInput.Button>
        <BarcodeInput.Button onClick={handleReturnBarcodeInputs}>확인</BarcodeInput.Button>
      </BarcodeInput.ButtonBox>
    </BarcodeInput.Wrapper>
  );
};
